import React from 'react'
import './AdaptableProjectNote.css'

const AdaptableProjectNote = () => (
    <p className="adaptable-project-note">
        <span aria-hidden="true">✦</span>
        Cet exemple n’est pas figé&nbsp;: les fonctionnalités, les étapes, les rôles, l’apparence et les
        connexions peuvent être adaptés à vos méthodes de travail et à vos priorités.
    </p>
)

export default AdaptableProjectNote
